import queryClient, { IQueryParams } from 'queries';
import helpers from 'helpers/index';
import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { TypedOrders } from './orders.query';
import { TypedTrip_manifest_ticket } from './trip_manifest_ticket.query';

export interface TypedTicket {
    ticket_id?: string;
    order_id?: string;
    price?: number;
    discount?: number;
    ticket_type?: ENUM_TICKET_TYPE;
    createdAt?: string;
    orders?: TypedOrders;
    trip_manifest_ticket?: TypedTrip_manifest_ticket;
}


export enum ENUM_TICKET_TYPE {
    PASSENGER = 'PASSENGER',
    SHIPMENT = 'SHIPMENT'
}

type IQuery = TypedTicket & IQueryParams;

/*
* List of all ticket
*/
export function useGetTickets(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["ticket/fetch_entity_list", object],
        queryFn: () => axios.get<TypedTicket[]>(`/ticket/${EndURL}`).then(response => response.data),
        retry: 1,
        enabled: !!object.order_id,
    });
}

export function useMutateGetTickets() {
    return useMutation({
        mutationKey: ['ticket/fetch_entity_list'],
        mutationFn: (object: IQuery) => axios.get<TypedTicket[]>(`/ticket/${helpers.buildEndUrl(object)}`).then((response) => response.data),
    })
};


/** Admin hủy vé ... */
export function useMutateTicketDelete() {
    return useMutation({
        mutationKey: ['ticket/admin_cancel'],
        mutationFn: (ticket_id: number | string) => axios.delete(`/ticket/${ticket_id}`).then((response) => response.data).catch(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
        }
    });
}


type TypedMergeTicket = {
    order_id: any,
    ticket_id: any[]
}

export function useMutateTicketMerge() {
    return useMutation({
        mutationKey: ['ticket/admin_merge'],
        mutationFn: (object: TypedMergeTicket) => axios.post<TypedTicket>(`/ticket/merge/`, object).then((response) => response.data),
        onSuccess: () => {
            // queryClient.invalidateQueries({ queryKey: ['orders/fetch_entity_list'] });
            // queryClient.invalidateQueries({ queryKey: ['ticket/fetch_unassigned_list'] }); // reset lại cái danh sách vé chưa điều chuyến
        }
    });
}



/** tách một vé ra khỏi một đơn, thành vé mới đơn mới */
export function useMutateTicketDetach() {
    return useMutation({
        mutationKey: ['ticket/admin_detach'],
        mutationFn: (ticket_id: any) => axios.post(`/ticket/detach/${ticket_id}`).then((response) => response.data),
        onSuccess: () => {
            /** giữ đây, không được động vào ... */
            queryClient.invalidateQueries({ queryKey: ['orders/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest_ticket/fetch_entity_list'] }); // reset lại cái danh sách vé để hiển thị
        }
    });
}
